module.exports = __webpack_public_path__ + "static/olm.9ddeb6b.wasm";